import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import accessRightService from './access-right-service';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import BreadcrumbComponent from '../../../../../components/Breadcrumb';


const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    'fullName': {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    representative: { value: null, matchMode: FilterMatchMode.IN },
    date: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    balance: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    status: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
};

interface RecordFilter {
    [key: string]: string | boolean | Date; // Adjust types as needed
}

const AccessRightList: React.FC = () => {
    const [accessRight, setAccessRight] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
    const navigate = useNavigate();
    const [clientState, setClientState] = useState<any>(null);

    const [recordFilter, setRecordFilter] = useState<RecordFilter>({});

    useEffect(() => {
        const fetchClientState = async () => {
            try {
                const clientStateItem = await accessRightService.getClientState();
                setClientState(clientStateItem);
            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, []);

    useEffect(() => {
        if (clientState) {
            const fetchUserList = async () => {
                try {

                    recordFilter.facilityCode = clientState.facilityCode;

                    accessRightService.findAllAccessRight(recordFilter).then((data) => {
                        setAccessRight(data);
                    });
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            };

            fetchUserList();
        }
    }, [clientState]);



    function handleCreate(): void {
        navigate(`/admin/access-right-edit`);
    }

    const handleEdit = (item: any) => {
        navigate('/admin/access-right-edit', { state: { selectedItem: item } });
    };

    const handleView = (item: any) => {

        navigate('/admin/access-right-view', { state: { item: item } });
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters(defaultFilters);
        setGlobalFilterValue('');
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between">
                <div>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </div>
                <div>
                    <Button icon="pi pi-print" severity="danger" style={{ marginRight: '.1em' }} onClick={() => handlePrint()} />
                    <Button label="New" icon="pi pi-plus" style={{ marginRight: '.5em' }} onClick={() => handleCreate()} />
                </div>
            </div>
        );
    };

    const header = renderHeader();

    function handlePrint(): void {
        window.print();
    };

    const actionTemplate = (rowData: any) => (
        <div style={{ display: 'flex', gap: '5px' }}>
            <Button
                label="Edit"
                icon="pi pi-pencil"
                className="p-button-warning p-button-sm "
                style={{ padding: '5px 5px', fontSize: '10px' }}
                onClick={() => handleEdit(rowData)}
            />
        </div>
    );

    return (
        <div className='grid'>
            <div className='col-12'>
                <div className='card-title'>
                    <h5>Access Right</h5>
                    <BreadcrumbComponent />
                </div>
                <div className='card'>
                    <>
                        <DataTable
                            value={accessRight}
                            showGridlines
                            scrollable
                            scrollHeight='auto'
                            paginator rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            filters={filters}
                            globalFilterFields={['fullDesc', 'facilityCode']}
                            header={header}
                            sortField='modifiedDate'
                            sortOrder={-1}
                        >
                            <Column
                                header="No."
                                style={{ width: '5%' }}
                                body={(_, { rowIndex }) => rowIndex + 1} // Render row number
                            ></Column>
                            <Column field="insertDate" header="Register Date" body={(rowData) => new Date(rowData.insertDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', })}></Column>
                            <Column field="fullDesc" header="Access Right Name"></Column>
                            <Column field="facilityCode" header="Facility" ></Column>
                            <Column field="recordStatus" header="Status" body={(rowData) => rowData.recordStatus === '1' ? 'Active' : 'Inactive'}></Column>
                            <Column body={actionTemplate} header="Actions" style={{ width: '20%' }} ></Column>
                        </DataTable>
                    </>
                </div>
            </div>
        </div>
    );
};

export default AccessRightList;
